import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMp4SizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      d="M16 7h2.5v2h1V7h.5V6h-.5V4.5h-1V6H17l1-4h-1l-1 3.87V7ZM7.5 4.382a1.494 1.494 0 0 0-1.7-.209V4H5v5h1V5.5a.5.5 0 0 1 1 0V9h1V5.5a.5.5 0 0 1 1 0V9h1V5.41l-.003-.002A1.5 1.5 0 0 0 7.5 4.382Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8 4.24V4H11v7h1.01V9h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V5.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24L12 5.55a.53.53 0 0 1 .16-.37Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 12v13H5V12h14Zm-3 12h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-1-2v5.056H9V19h6Zm0-1H9v-5.056h6V18Zm1 0h2v-2h-2v2Zm0-3h2v-2h-2v2Zm-8 1v2H6v-2h2Zm-2 5v-2h2v2H6Zm0 1v2h2v-2H6Zm2-7v-2H6v2h2Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMp4SizeS;
